(function () {

  async function syncCounter() {
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await res.json();

      const counter = document.querySelector('[data-cart-count]');
      if (!counter) return;

      counter.textContent = cart.item_count;

      if (cart.item_count > 0) {
        counter.classList.remove('hidden');
      } else {
        counter.classList.add('hidden');
      }

    } catch (e) {}
  }

  // roda após o Fabric terminar
  window.addEventListener('load', () => {
    setTimeout(syncCounter, 200);
  });

})();